import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'bjorns_backyard';
// export const customerGroup = 'default_in_preparation';

const supportEmail = {
	[customerGroup]: 'bjorns_backyard@smoothr.de',
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyDEotTdHGF5Q_Vi5Nx8ogTSl-uaO6PwMjQ',
		authDomain: 'bjorns-backyard.firebaseapp.com',
		projectId: 'bjorns-backyard',
		storageBucket: 'bjorns-backyard.firebasestorage.app',
		messagingSenderId: '879121573408',
		appId: '1:879121573408:web:0b005e4a6f3fa103b1be45',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyBxctZyYOPXBxP8pv-IsX0F3y16TB3nCFU',
	baseUrl: 'https://api.smoothr.de',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	allergens_link: '',
	hasRecommendations: true,
	...apiEnvironment,
	hjid: 5035140,
	merchantId: '3000032502',
	merchantGoogleId: 'BCR2DN7TRCR2NIBO',
};
